module.exports = __webpack_public_path__ + "static/media/19ESCAP24.509acbe4.jpg";